import { PayloadAction } from '@reduxjs/toolkit';
import { StatusLoading } from 'common/constants/statusLoading';

import { IState } from '../types/state';

const action = (
  state: IState,
  payloadAction: PayloadAction<{
    folderId: number;
    statusLoading: StatusLoading;
  }>,
) => {
  const { folderId, statusLoading } = payloadAction.payload;

  state.catalogs.data = {
    ...state.catalogs.data,
    [folderId]: {
      ...state.catalogs.data[folderId],
      statusLoading,
    },
  };
};

export default action;
